import { IS_STAGING, language, PROPERTY } from '../shared/config';

let hasTrackedChatOpen = false;

const trackOnce = (eventName: string) => {
  if (hasTrackedChatOpen) return;
  hasTrackedChatOpen = true;
  if (window.gtag) {
    window.gtag('event', eventName);
    console.log(`Event ${eventName} sent to GTM`);
  }
};

export const setupChatButtonListeners = (selector: string, eventName: string, openFn: () => void) => {
  document.querySelectorAll(selector).forEach((button: HTMLButtonElement) => {
    button.onclick = null;
    button.addEventListener('click', () => {
      if (eventName) {
        trackOnce(eventName);
      }
      if (openFn) {
        openFn();
      }
    });
  });
};

export const setupChatButtons = (configs: { selector: string; eventName: string; openFn: () => void }[]) => {
  configs.forEach(({ selector, eventName, openFn }) => {
    setupChatButtonListeners(selector, eventName, openFn);
  });
};


export const setupIntercomButtons = () => {
  setupChatButtons([
    {
      selector: '.chat-launcher',
       eventName: 'chat_click_nav_intercom',
      openFn: () => window.Intercom('show'),
    },
    {
      selector: '.chat-button',
      eventName: 'chat_click_nav_intercom',
      openFn: () => window.Intercom('show'),
    },
    {
      selector: '.chat-button-hero',
      eventName: 'chat_click_hero_intercom',
      openFn: () => window.Intercom('show'),
    },
    {
      selector: '.chatbot-bubble-btn',
      eventName: 'chat_click_bubble_intercom',
      openFn: () => window.Intercom('show'),
    },
  ]);
};

export const createAndAppendIntercom = ({
  visitToken,
  campaignId,
  sourceId,
  phoneNumber,
  variant,
  experimentName,
  property = PROPERTY,
  regionCode,
}: {
  visitToken: string;
  campaignId: string;
  sourceId: string;
  phoneNumber?: string;
  variant?: string;
  experimentName?: string;
  property?: string;
  regionCode?: string | null;
}) => {
  const environment = IS_STAGING ? 'staging' : 'production';
  const chatbotBubbleContainer = document.querySelector('.chatbot-container_new');
  if (chatbotBubbleContainer) {
    (chatbotBubbleContainer as HTMLElement).style.display = 'flex';
  }
  const settingsScript = document.createElement('script');
  const icLang = language === 'spanish' ? 'es' : 'en';
  settingsScript.type = 'text/javascript';
  settingsScript.textContent =
    'window.intercomSettings = {' +
    'api_base: "https://api-iam.intercom.io",' +
    'app_id: "pm91jsiz",' +
    `language_override: "${icLang}",` +
    `hide_default_launcher: ${true},` +
    `visit_token: "${visitToken}",` +
    `campaign_id: "${campaignId}",` +
    `source_id: "${sourceId}",` +
    `current_page: "${window.location.pathname}",` +
    `environment: "${environment}",` +
    (phoneNumber ? `phone_number: ${JSON.stringify(phoneNumber)},` : '') +
    (variant ? `variant: ${JSON.stringify(variant)},` : '') +
    (experimentName ? `experiment_name: ${JSON.stringify(experimentName)},` : '') +
    `property: "${property}",` +
    (regionCode ? `region_code: ${JSON.stringify(regionCode)},` : '') +
    '};';
  document.head.appendChild(settingsScript);
  const widgetScript = document.createElement('script');
  widgetScript.type = 'text/javascript';
  widgetScript.textContent =
    '(function(){' +
    'var w=window;var ic=w.Intercom;' +
    'if(typeof ic==="function"){' +
    "ic('reattach_activator');ic('update',w.intercomSettings);" +
    '}else{' +
    'var d=document;var i=function(){i.c(arguments);};' +
    'i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;' +
    'var l=function(){' +
    'var s=d.createElement("script");' +
    's.type="text/javascript";s.async=true;' +
    "s.src='https://widget.intercom.io/widget/pm91jsiz';" +
    'var x=d.getElementsByTagName("script")[0];' +
    'x.parentNode.insertBefore(s,x);' +
    '};' +
    "if(document.readyState==='complete'){l();}" +
    'else if(w.attachEvent){w.attachEvent("onload",l);}' +
    'else{w.addEventListener("load",l,false);}' +
    '}' +
    '})();';
  document.head.appendChild(widgetScript);
};

